//css-------------------
import "@/css/home/welcome.scss";
import "@/css/share/components/_ind_kv.scss";
import "@/css/share/components/_ind_entries.scss";
import "@/css/share/components/_ind_news.scss";
import "@/css/share/components/_ind_event.scss";




//components js-------------------
// 合併成單一 chunk（home_async），減少請求數
import(/* webpackChunkName: "home_async", webpackPrefetch: true */ "@/js/share/components/_common_lazy");
import(/* webpackChunkName: "home_async", webpackPrefetch: true */ "@/js/share/components/_font_family");
import { init_imageloaded } from "@/js/share/components/_imageloader.js";
import { sponsor_swiper } from "@/js/share/components/_sponsor_swiper.js";
import { list_swiper } from "@/js/share/components/_list_swiper.js";



//npm lib  
import $ from "jquery";
import { createApp, baseData, baseWatch, baseMethods } from "@/js/share/_home_app";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";

const app = createApp({
    data() {
        return {
            ...baseData(),
            event_row: $event_row,
            event_current_index: 0,
            mouseX: 0,
            mouseY: 0,
        };
    },
    watch: {
        ...baseWatch(this),
    },
    mounted() {
        const _this = this;
        this.fastlink_toggle();
        init_imageloaded(function () {
            // 將兩個 Swiper 的初始化拆到不同的 animation frame，
            // 避免 updateSize() 在 DOM 變動後立即讀取幾何屬性所造成的
            // 強制同步重排（forced reflow / layout thrashing）。
            requestAnimationFrame(function () {
                list_swiper();
                requestAnimationFrame(function () {
                    sponsor_swiper();
                });
            });
        });
    },
    methods: {
        ...baseMethods,
        array_move(arr, old_index, new_index) {
            if (new_index >= arr.length) {
                var k = new_index - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);

            return arr;
        },
        event_handler(index) {
            this.event_current_index = index;
            this.array_move(this.event_row, index, 0);
            console.log("event_handler", this.event_row);
        },
        form_submit() {
            location.href = '/schedule?date=' + $('select[name=date]').val() + '&cinema=' + $('select[name=cinema]').val();
        }
    },
}).mount("#app");
